import React, { Component } from "react";
import { Link } from "react-router-dom";
import ClassModal from "../../ClassModal";
import LayoutWrapper from "../../LayoutWrapper";
import mixins from "../../mixins";
import { ToastContainer, toast } from "react-toastify";

export class AddARVR extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("AddARVR");
    this.state = {
      data: [],
      rowcount: 0,
      search: {
        limit: 20,
        orderBy: "updatedAt",
        orderDirection: "DESC",
        page: 1,
        filter: {
          session_id: props?.urlparams?.session_id,
        },
      },
      editData: {},
      viewMode: false,
      editMode: false,
      popupfields: {},
      popupdata: {},
      modalFields: [
        {
          type: "select",
          name: "arvr_content_title",
          label: "Augmented Reality",
          options: [],
          required: true,
          customcolspan: "col-12",
        },
        {
          type: "file",
          name: "attach_file",
          label: "Thumbnail",
          fileType: "module",
          accept: "image/*",
          required: true,
          customcolspan: "col-12",
        },
        {
          type: "textarea",
          name: "arvr_content_description",
          label: "Description",
          customcolspan: "col-12",
        },
      ],
    };
    this.tablinks = mixins.tablinks;
    this.columns = [
      {
        dataIndex: "arvr_content",
        title: "Name",
        render: (text, record) => {
          return <>{record?.arvr_content[0]?.title || "-"}</>;
        },
      },
      {
        dataIndex: "arvr_content_description",
        title: "Description",
        render: (text, record) => {
          return (
            <span
              className="text_truncate w-200px cursor-pointer"
              title={record?.arvr_content_description}
              onClick={() => alert(record?.arvr_content_description)}
            >
              {record?.arvr_content_description}
            </span>
          );
        },
      },
      {
        dataIndex: "createdAt",
        title: "Created on",
        render: (text) => {
          return <>{new Date(`${text}`).toLocaleDateString()}</>;
        },
      },
    ];
    this.modalRef = React.createRef();
  }

  getGradeLevelParams() {
    return {
      grade: this.props.urlparams.grade,
      // // level: this.props.urlparams.level,
      curriculum_id: this.props.urlparams.curriculum_id,
      // school_id: this.props.urlparams.school_id,
      // class_id: this.props.urlparams.class_id,
      session_id: this.props.urlparams.session_id,
    };
  }

  getPillarParams() {
    return this.props.urlparams.type;
  }

  downloadFile(fileId) {
    let authToken = window.store.getState().root.auth;
    // console.log({ authToken: authToken });
    return (
      app.api
        .request(app.apis().fileDownloader)
        .urltransform({ attachmentId: fileId }).url +
      "?auth=" +
      authToken
    );
  }

  sumitForm(event, data, form) {
    console.log({ addARVR: data });
  }

  componentDidMount() {
    this.fetchData();
    this.getMasterLists();
  }

  addModalFields() {
    let fields = (this.state.modalFields || []).reduce(
      (o, n) => ({ ...o, [n.name]: n }),
      {}
    );
    let formdata = Object.map(fields, (v, k) => "");
    // console.log("formdata: ", fields, formdata);
    this.setState({
      popupfields: fields,
      popupdata: formdata,
    });
  }

  fetchData() {
    let payload = { session_id: this.props.urlparams.session_id };
    this.props.api
      .apiGetARVRContents(payload)
      .then(({ data, total }) => {
        console.log({ data });

        if (data) {
          this.setState({
            data,
            rowcount: total,
          });
        }
      })
      .catch(() => {
        this.setState({ loader: false });
      });
  }

  getMasterLists() {
    let payload = {};
    this.props.api
      .apiGetARVRMasterList(payload)
      .then(({ data, total }) => {
        console.log({ data });

        if (data) {
          let titleField = this.state.modalFields.find(
            (o) => o.name == "arvr_content_title"
          );
          titleField.options = data?.options("arvr_id", "title");

          this.setState({
            modalFields: this.state.modalFields,
          });
        }
      })
      .catch(() => {
        this.setState({ loader: false });
      });
  }

  openModal() {
    this.modalRef.current.click();
  }

  editAction(v) {
    console.log("edit: ", v);
    this.openModal();
    this.setState((prevState) => ({
      popupdata: {
        ...Object.only(v, [
          "arvr_content_title",
          "arvr_content_description",
          "attach_file",
        ]),
      },
      editMode: true,
      viewMode: false,
      editData: v,
    }));
  }

  viewAction(v) {
    console.log("view: ", v);
    this.openModal();
    this.setState((prevState) => ({
      popupdata: {
        ...Object.only(v, [
          "arvr_content_title",
          "arvr_content_description",
          "attach_file",
        ]),
      },
      editMode: false,
      viewMode: true,
    }));
  }

  deleteAction(v) {
    console.log("delete ", v);

    confirm(`Do you really want to delete these record?`).promise.then(() => {
      this.props.api
        .apiDeleteARVR({
          arvr_content_id: v.arvr_content_id,
        })
        .then((res) => {
          this.fetchData();
        })
        .catch((error) => {
          console.error(error);
        });
    });
  }
  onPageChange(pageData) {
    this.setState(
      {
        search: {
          ...this.state.search,
          page: pageData.current,
          limit: pageData.pageSize || pageData.defaultPageSize || 25,
        },
      },
      (state) => this.fetchData()
    );
  }

  closeModal() {
    document.querySelector("#arvr_modal #bsmodalclose").click();
  }

  handleSubmit(e, data, form) {
    e.preventDefault();

    let formData = e.target.getData();
    const resolveList = () => {
      this.fetchData();
      form.reset();
    };

    if (this.state.editMode) {
      let payload = {
        ...formData,
      };
      this.props.api
        .apiUpdateARVR(payload, {
          arvr_content_id: this.state.editData.arvr_content_id,
        })
        .then((res) => {
          toast.success("AR VR Updated Successfully", {
            autoClose: 3000,
            closeButton: false,
            hideProgressBar: true,
          });
          this.closeModal();
          resolveList();
        });
    } else {
      let payload = {
        session_id: this.props.urlparams.session_id,
        ...formData,
      };
      this.props.api.apiCreateARVR(payload).then((data) => {
        this.setState({
          data: data,
        });
        toast.success("AR VR Added Successfully", {
          autoClose: 3000,
          closeButton: false,
          hideProgressBar: true,
        });
        this.closeModal();
        resolveList();
      });
    }
  }

  getBreadCums() {
    if (this.props.urlparams.grade) {
      return `Content Management / ${
        this.props.urlparams.grade
      } Grade / Courses / ${this.props.urlparams.type.toTitleCase()} / Add Session`;
    } else {
      return "Content Management / Sessions";
    }
  }

  getBackLink() {
    if (this.props.urlparams.grade) {
      let backLink = `/contentmanagement/pillarspage?grade=${this.props.urlparams.grade}&level=${this.props.urlparams.level}&curriculum_id=${this.props.urlparams.curriculum_id}&session_id=${this.props.urlparams.session_id}`;
      return backLink;
    } else {
      return "/contentmanagement/sessions";
    }
  }

  render() {
    let { tablinks, columns } = this;
    let {
      data = [],
      rowcount,
      editData,
      popupdata,
      popupfields,
      editMode,
      viewMode,
    } = this.state;
    return (
      <LayoutWrapper
        title="Content Management"
        back={this.getBreadCums()}
        backlink={this.getBackLink()}
      >
        <ToastContainer position="top-right" />
        <AppLinkTabs data={tablinks} className="mb-0"></AppLinkTabs>
        <div className="row m-auto">
          <div className="col"></div>
          <div className="mb-4"></div>
        </div>
        <div className="row m-auto">
          <div className="col-12 mb-4">
            <Link
              className={Object.className({
                "btn add-btn ml-auto": true,
                hidden: this.props.urlparams.readonly == 1 ? true : false,
              })}
              ref={this.modalRef}
              data-bs-toggle="modal"
              data-bs-target="#arvr_modal"
              onClick={(...args) => this.addModalFields(...args)}
            >
              <i className="fa fa-plus"></i>
              Add Augmented Reality
            </Link>
          </div>
        </div>

        <div className="row">
          <div className="col-12">
            {!!data.length && (
              <AppTable
                data={data}
                columns={columns}
                onNext={() => this.onNext()}
                onPrev={() => this.onPrev()}
                onChange={(...arg) => this.onPageChange(...arg)}
                total={rowcount}
                reorder={true}
                deleteAction={(v) => this.deleteAction(v)}
                editAction={(v) => this.editAction(v)}
                viewAction={(v) => this.viewAction(v)}
                editable={this.props.urlparams.readonly == 1 ? false : true}
                // deletable={this.props.urlparams.readonly == 1 ? false : true}
                pageSize={50}
                targetType="tap"
              ></AppTable>
            )}
            {data.length == 0 && <div className="empty_layout"></div>}
          </div>
        </div>

        <div className="row m-auto">
          <div className="col-12 mt-4">
            <Link
              to={`/contentmanagement/sessions/addassessments${Object.encodeuri(
                this.getGradeLevelParams()
              )}&type=${this.getPillarParams()}&${Object.QueryString({
                new: 1,
              })}`}
              className="btn add-btn ms-3"
            >
              Save & Next
            </Link>
            <Link
              to={`/contentmanagement/sessions/addassessments${Object.encodeuri(
                this.getGradeLevelParams()
              )}&type=${this.getPillarParams()}&${Object.QueryString({
                new: 1,
              })}`}
              className="btn btn_primary grey col col-md-1 float-right"
            >
              Skip
            </Link>
          </div>
        </div>
        <ClassModal
          id="arvr_modal"
          title={`${
            editMode ? "Update Augmented Reality" : "Add Augmented Reality"
          }`}
          submitText={`${editMode ? "Update" : "Submit"}`}
          editdata={editData}
          data={popupdata}
          fields={popupfields}
          disableallfields={viewMode ? true : false}
          onSubmit={(...args) => this.handleSubmit(...args)}
          onClose={() =>
            this.setState({
              popupdata: {},
              editData: {},
              editMode: false,
              viewMode: false,
            })
          }
        />
      </LayoutWrapper>
    );
  }
}

export default connect(AddARVR);
